import { isCompanyCuit } from "../../utils/utils";

const validate = values => {
	const errors = {}
	if (!values.email) {
		errors.email = 'Este Campo es Obligatorio'
	}
	if (values.document_number && !/(\d{7}|\d{8})$/.test(values.document_number)) {
		errors.document_number = 'El documento no es válido'
	}
	if (!values.area_code) {
		errors.area_code = 'Este Campo es Obligatorio'
	}
	if (!values.number) {
		errors.number = 'Este Campo es Obligatorio'
	}
	if (!values.state_id || values.state_id === 'false') {
		errors.state_id = 'Este Campo es Obligatorio'
	}
	return errors
}

export default validate


/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsMainForm.js
 **/